import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import { useAuth } from '../utils/auth';
import { useDialog } from '../utils/dialog';
import store, { actions } from '../redux/store';

const RouteGuard = ({
  Component,
  properties,
  name,
  path,
  meta,
  isMenuItem,
  nodeOnly,
  hasChildren,
  shouldPageUpdated,
}) => {
  const auth = useAuth();
  const dialog = useDialog();
  const history = useHistory();

  const [mounted, setMounted] = useState();

  const checkAuth = useCallback(() => {
    const localStoredAccountCode = localStorage.getItem('ac');

    const sessionStoredToken = sessionStorage.getItem('st');
    const sessionStoredMemberID = sessionStorage.getItem('mi');
    const sessionStoredAccountCode = sessionStorage.getItem('ac');
    const sessionStoredIsAdmin = sessionStorage.getItem('ia') === 'true';

    const storedIsAdminHasStringValue =
      sessionStorage.getItem('ia') === 'true' ||
      sessionStorage.getItem('ia') === 'false';

    if (
      (!meta || !meta.authFree) &&
      (!auth || !auth.user || !auth.user.sessionToken)
    ) {
      if (
        sessionStoredToken &&
        sessionStoredMemberID &&
        (localStoredAccountCode || sessionStoredAccountCode) &&
        storedIsAdminHasStringValue
      ) {
        auth.signin({
          redirectPath: null,
          sessionToken: sessionStoredToken,
          memberID: sessionStoredMemberID,
          accountCode: localStoredAccountCode || sessionStoredAccountCode,
          isAdmin: sessionStoredIsAdmin,
        });
      } else {
        auth.signout({ resetLocalStorage: false });
        const redirectPath = (history.location.pathname || '').replace(
          '/',
          '_'
        );
        history.push(`/login?rp=${redirectPath}`);
      }
    } else {
      if (
        !mounted &&
        (name === 'login' || name === 'register') &&
        sessionStoredToken
      ) {
        if (name === 'register')
          dialog.openAlert({ message: '請先登出再進行操作' });
        history.replace('/');
      } else {
        setMounted(true);
      }
    }
  }, [meta, auth, dialog, history, mounted, name]);

  useEffect(() => {
    store.dispatch(actions.setData(meta));
  }, [meta]);

  useEffect(() => {
    if (nodeOnly) return;

    store.dispatch(
      actions.setCurrentRoute({
        name,
        path,
        isMenuItem,
        hasChildren,
      })
    );
  }, [name, path, isMenuItem, hasChildren, nodeOnly]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <>
      {mounted ? (
        <Component
          {...properties}
          meta={meta}
          shouldPageUpdated={shouldPageUpdated}
        />
      ) : undefined}
    </>
  );
};

RouteGuard.propTypes = {
  Component: PropTypes.func,
  properties: PropTypes.object,
  name: PropTypes.string,
  path: PropTypes.string,
  meta: PropTypes.object,
  isMenuItem: PropTypes.bool,
  nodeOnly: PropTypes.bool,
  hasChildren: PropTypes.bool,
  shouldPageUpdated: PropTypes.bool,
};

export default RouteGuard;
